import React from 'react';

import { Text } from 'platform-components';

import { getIsCollegeTeamUtil } from '../../common.components/user/utils';

interface Params {
    schoolName: string | null;
    grade: number | null;
}

/** Возвращает название школы с учетом грейда класса и СПО  */
export const getTeamSchoolName = ({ grade, schoolName }: Params) => {
    if (!schoolName) {
        return <Text id="class.schoolName.schoolNotDefined" />;
    }

    const isCollegeTeam = getIsCollegeTeamUtil(grade);

    return <Text id={isCollegeTeam ? 'class.schoolName.college' : 'class.schoolName.school'} />;
};
